import axios from "axios";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import ReactSelect from "../../../Components/PortalSelect";
import { RevertBackSchema } from "../../../ValidationSchema";
import Modal, { KeyValue } from "../../../Components/Modal";
import { formatMoney } from "../../../utils/money";

const SupplierApprovalQuotes = ({
  show,
  userId,
  orderId,
  productData,
  onClose,
}) => {
  const Navigate = useNavigate();
  // const [isModalOpen, setIsModalOpen] = useState(false);
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const [data, setData] = useState([]);
  const [totalpage, setTotalPage] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [activePreviewIndex, setActivePreviewIndex] = useState(0);

  const handleThumbnailClick = (index) => {
    setActivePreviewIndex(index);
  };

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      border: "1px solid #bfc9d4",
      boxShadow: "#000 !important",
      borderRadius: "6px",
      padding: "4px",
      "&:hover": {
        border: "1px solid #bfc9d4",
      },
    }),
    multiValue: (styles) => {
      return {
        ...styles,
        backgroundColor: "#606060",
      };
    },
    multiValueLabel: (styles) => ({
      ...styles,
      color: "#fff",
    }),
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: "#000",
      "& > svg": {
        backgroundColor: "#fff",
        borderRadius: "10px",
        marginLeft: "2px",
        marginRight: "2px",
      },
      ":hover": {
        backgroundColor: data.color,
        color: data.color,
      },
    }),
    option: (styles, { data }) => {
      return {
        ...styles,
        backgroundColor: "white",
        color: "#000",
        ":hover": {
          backgroundColor: "#f5f5f5",
        },
      };
    },
  };

  const fetchSupplierApprovalDetails = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL}/admin/supplier-approved-order?order_id=${orderId}`,
        {
          headers: {
            "j-authorization": localStorage.getItem("Token"),
          },
        }
      );

      setData(res?.data?.data[0]);
    } catch (error) {
      console.error("Failed to fetch design studio details", error);
    }
  };

  useEffect(() => {
    fetchSupplierApprovalDetails();
  }, [userId, orderId]);

  React.useEffect(() => {}, []);

  // Was two nested .modal-overlay layers — one scrim painted on top of another.
  return (
    <Modal
      open={!!show}
      onClose={onClose}
      title="Supplier Quotation"
      subtitle="Quotation approved by sub admin"
      size="md"
      footer={
        <button type="button" className="al-btn" onClick={onClose}>
          Close
        </button>
      }
    >
      <div className="al-kv">
        <KeyValue label="Supplier">{data?.userData?.name || "—"}</KeyValue>
        <KeyValue label="Product">{data?.productdata?.title || "—"}</KeyValue>
        <KeyValue label="Price">
          {formatMoney(data?.price)}
        </KeyValue>
        <KeyValue label="Status">
          {data?.quotationApproved === 1 ? (
            <span
              className="al-pill"
              style={{
                background: "var(--color-success-bg)",
                color: "var(--color-success-text)",
              }}
            >
              Approved
            </span>
          ) : (
            <span
              className="al-pill"
              style={{
                background: "var(--color-warning-bg)",
                color: "var(--color-warning-text)",
              }}
            >
              Pending
            </span>
          )}
        </KeyValue>
      </div>

      <div style={{ marginTop: 16 }}>
        <KeyValue label="Remark">{data?.remark || "—"}</KeyValue>
      </div>
    </Modal>
  );
};

export default SupplierApprovalQuotes;
